<template>
  <div id="configuratorFrame3d">
    <canvas ref="bjsCanvas" style="width: 100%; height: 100%;"/>
  </div>
</template>

<script>
import myScene from "../scenes/FrameScene";

export default {
  name: 'configuratorTableOffice3d',
  data() {
    return{
    }
   },
   components: {
     },
   computed: {
     getDimensions() {return this.$store.getters.getFrameConfig.dimensions},
     getFiller(){return this.$store.getters.getFrameConfig.filling.type},

     getWhiteboardColorR(){ return parseInt(this.$store.getters.getFrameConfig.filling.whiteboard.color.slice(1,3), 16)/256 },
     getWhiteboardColorG(){ return parseInt(this.$store.getters.getFrameConfig.filling.whiteboard.color.slice(3,5), 16)/256 },
     getWhiteboardColorB(){ return parseInt(this.$store.getters.getFrameConfig.filling.whiteboard.color.slice(5,8), 16)/256 },
     getMirrorColorR(){ return parseInt(this.$store.getters.getFrameConfig.filling.mirror.color.slice(1,3), 16)/256 },
     getMirrorColorG(){ return parseInt(this.$store.getters.getFrameConfig.filling.mirror.color.slice(3,5), 16)/256 },
     getMirrorColorB(){ return parseInt(this.$store.getters.getFrameConfig.filling.mirror.color.slice(5,8), 16)/256 },
     getBlackboardColorR(){ return parseInt(this.$store.getters.getFrameConfig.filling.blackboard.color.slice(1,3), 16)/256 },
     getBlackboardColorG(){ return parseInt(this.$store.getters.getFrameConfig.filling.blackboard.color.slice(3,5), 16)/256 },
     getBlackboardColorB(){ return parseInt(this.$store.getters.getFrameConfig.filling.blackboard.color.slice(5,8), 16)/256 },
     getPassepartoutColorR(){ return parseInt(this.$store.getters.getFrameConfig.filling.passepartout.color.slice(1,3), 16)/256 },
     getPassepartoutColorG(){ return parseInt(this.$store.getters.getFrameConfig.filling.passepartout.color.slice(3,5), 16)/256 },
     getPassepartoutColorB(){ return parseInt(this.$store.getters.getFrameConfig.filling.passepartout.color.slice(5,8), 16)/256 },
     getPassepartoutColor(){ return this.$store.getters.getFrameConfig.filling.passepartout.color},

     height(){ return this.getDimensions.height},
     width(){ return this.getDimensions.width },
     depth(){ return 3 },
     thikness(){ return 4 },

     xPosition() { return (this.width/2 - this.thikness/2) },
     yPosition() { return (this.height/2 - this.thikness/2) },

     heightOfFrame() { return (140) },

     xPositionPassepartout() { return (3/8*this.width-this.thikness/2)},
     yPositionPassepartout() { return (3/8*this.height-this.thikness/2)},

     faceWidthPos1(){ return ((142-(this.width-8))/2)/142},
     faceWidthPos2(){ return (((142-(this.width-8))/2)+(this.width-8))/142},
     faceHeightPos1(){ return ((150-this.height)/2)/150},
     faceHeightPos2(){ return (((150-this.height)/2)+this.height)/150},
     getMobile(){return this.$store.getters.getAnimationProperties.mobile},
     cameraDistance() {
       var distance = 350
       if(this.getMobile){
         distance = 400
       }
       return distance
     },
   },
   methods: {
   },
   mounted (){
     const bjsCanvas = this.$refs.bjsCanvas;
     if (bjsCanvas) {
       myScene.createScene(bjsCanvas);
     }
   },
   watch: {
     height(){
        myScene.setHeight(this.height, this.faceHeightPos1, this.faceHeightPos2);
        if(this.getfiller != ''){
          myScene.setFiller(this.width, this.height, this.getFiller)
        }
     },
     width(){
        myScene.setWidth(this.width, this.faceWidthPos1, this.faceWidthPos2);
        if(this.getfiller != ''){
          myScene.setFiller(this.width, this.height, this.getFiller)
        }
     },
     getFiller(){
       var red = 0
       var green = 0
       var blue = 0
       switch (this.getFiller){
         case 'whiteboard':
           red = this.getWhiteboardColorR
           green = this.getWhiteboardColorG
           blue = this.getWhiteboardColorB
         break;
         case 'mirror':
           red = this.getMirrorColorR
           green = this.getMirrorColorG
           blue = this.getMirrorColorB
         break;
         case 'blackboard':
           red = this.getBlackboardColorR
           green = this.getBlackboardColorG
           blue = this.getBlackboardColorB
         break;
         case 'passepartout':
           red = this.getPassepartoutColorR
           green = this.getPassepartoutColorG
           blue = this.getPassepartoutColorB
         break;
         default:
           red = 0
           green = 0
           blue = 0
         break;
       }
       myScene.setColor(red, green, blue)
       myScene.setFiller(this.width, this.height, this.getFiller)
     },
     getPassepartoutColor(){
       myScene.setColor(this.getPassepartoutColorR, this.getPassepartoutColorG, this.getPassepartoutColorB)
     }
   },
}
</script>

<style scoped>
  #configuratorFrame3d {
    height: 100%;
    width: 100%;
  }
  #renderCanvas {
    width: 100%;
    height: 100%;
    touch-action: none;
  }
</style>
